import React, { memo } from 'react'
import { Card, Stack } from '@mui/material'

import { ACCOUNT_PROFILE_DISPATCH } from '../../store/reducers/account/account'
import customConfig from 'customConfig'
import SubmitButton from '../shared/button/SubmitButton'
import CardHeading from '../text/CardHeading'
import CustomForm from '../shared/inputs/CustomForm'
import CustomAutoComplete from '../shared/inputs/CustomAutoComplete'
import { FlagIcon } from '../flag-icon'
import { buildCountriesOptions } from '../../util/country.helpers'
import { countriesObj } from '../../data/countries'

const ChangeCountry = ({
  onFormSubmit,
  dispatchAction,
  accountProfile: { error, success, countryTemp, isProcessing },
  t,
  isPresent
}) => {
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CustomForm onFormSubmit={onFormSubmit}>
        <CardHeading
          title={t('country-settings.country')}
          desc={t(customConfig.countrySettingsDescLabel)}
        />
        <CustomAutoComplete
          label={t('country-settings.country')}
          placeholder={t('shop.select-option')}
          options={buildCountriesOptions()}
          error={t(error[ACCOUNT_PROFILE_DISPATCH.COUNTRY_TEMP])}
          success={t(success[ACCOUNT_PROFILE_DISPATCH.COUNTRY_TEMP])}
          value={
            countryTemp
              ? { value: countryTemp, label: countriesObj[countryTemp] }
              : {}
          }
          onChange={(value) =>
            dispatchAction(ACCOUNT_PROFILE_DISPATCH.COUNTRY_TEMP, value)
          }
          startIcon={
            countryTemp && (
              <FlagIcon
                code={countryTemp}
                sx={{ width: 24, height: 24, borderRadius: '50%' }}
              />
            )
          }
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.value}>
                <FlagIcon
                  code={option.value}
                  sx={{ width: 24, height: 24, borderRadius: '50%', mr: 1 }}
                />
                {option.label}
              </li>
            )
          }}
        />
        <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
          <SubmitButton
            size='default'
            label={t('common.save')}
            loading={isPresent && isProcessing}
          />
        </Stack>
      </CustomForm>
    </Card>
  )
}

export default memo(ChangeCountry)
